<template>
  <v-dialog
    v-if="dialogValue"
    v-model="dialogValue"
    width="800"
    @click:outside="dialogValue = false"
    class="dialog"
  >
    <v-card class="automationCard">
      <div class="automationCard-header">
        <div class="automationCard-header-title">
          <h2>{{ auto.name }}</h2>
        </div>
        <div class="automationCard-header-actions">
          <v-switch
            :disabled="!$userPermissions.permitted('edit-user-automations')"
            v-model="auto.status"
            :prepend-icon="auto.status ? 'mdi-flash' : 'mdi-flash-off'"
            color="success"
            :false-value="auto.status == 0"
            inset
            hide-details
            @click="toggleAutomation()"
          >
          </v-switch>
          <v-btn color="grey darken-2" icon @click="editAutomation">
            <v-icon>settings</v-icon>
          </v-btn>
          <v-btn color="red" icon @click="$emit('delete')">
            <v-icon>delete</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="d-flex flex-row justify-start align-center mt-4">
        <v-chip color="blue" outlined class="me-3">
          {{ auto.automation_ifs.length }} {{ $t("then") }}
        </v-chip>
        <v-chip color="purple" outlined class="me-3">
          {{ auto.automation_thens.length }} {{ $t("when") }}
        </v-chip>
        <v-chip
          v-if="'automation_ends' in auto && auto.automation_ends.length"
          color="orange"
          outlined
          class="me-3"
        >
          {{ auto.automation_ends.length }} {{ $t("end") }}
        </v-chip>
      </div>
      <div class="automation-content-block">
        <div class="mt-4 text-subtitle-0">{{ $t("when") }}:</div>
        <div class="ifsContainer px-4">
          <ifRowContent
            v-for="(ifRow, index) in auto.automation_ifs"
            :key="index"
            :ifRow="ifRow"
          />
        </div>
        <!-- <div class="mt-4 text-subtitle-0">
          {{ $t("delayTime") }}:
          {{ auto.delay_time ? auto.delay_time : $t("noDelay") }}
          <span v-if="auto.delay_time">{{ $t("seconds") }}</span>
        </div> -->
        <div class="mt-4 text-subtitle-0">
          <v-alert
            color="purple"
            icon="mdi-timelapse"
            outlined
            dense
            text
            type="success"
          >
            {{ $t("delayTime") }}:
            {{ auto.delay_time ? auto.delay_time : $t("noDelay") }}
            <span v-if="auto.delay_time">{{ $t("seconds") }}</span>
          </v-alert>
        </div>
      </div>
      <div class="automation-content-block">
        <div class="mt-4 text-subtitle-0">{{ $t("then") }}:</div>
        <div class="thensContainer px-4">
          <thenRowContent
            v-for="(thenRow, index) in auto.automation_thens"
            :key="index"
            :thenRow="thenRow"
          />
        </div>
      </div>
      <div
        v-if="'automation_ends' in auto && auto.automation_ends.length"
        class="automation-content-block"
      >
        <div class="mt-4 text-subtitle-0">{{ $t("end") }}:</div>
        <div class="endsContainer px-4">
          <endRowContent
            v-for="(endRow, index) in auto.automation_ends"
            :key="index"
            :endRow="endRow"
          />
        </div>
      </div>
      <div
        class="d-flex justify-center align-center mt-4"
        @click="$emit('close')"
      >
        <v-btn color="grey darken-2" text>{{ $t("closeIt") }}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import ifRowContent from "./ifRowContent.vue";
import thenRowContent from "./thenRowContent.vue";
import endRowContent from "./endRowContent.vue";
export default {
  name: "AutomationConfigurationsDetails",
  props: {
    uuid: {
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    ifRowContent,
    thenRowContent,
    endRowContent,
  },
  data() {
    return {
      //
    };
  },
  computed: {
    dialogValue: {
      get() {
        return this.dialog;
      },
      set() {
        this.$emit("close");
      },
    },
    auto() {
      return this.$store.getters["automations/automation"](this.uuid);
    },
    devices() {
      const devices = this.$store.getters["devices/devices"];
      return Object.values(devices);
    },
  },
  // mounted() {
  //   console.log("mounted", this.auto);
  // },
  methods: {
    device(identifier) {
      return this.devices && identifier
        ? this.devices.filter((d) => d.identifier == identifier)[0]
        : null;
    },
    action(val) {
      return this.actions.filter((a) => a.value == val)[0];
    },
    editAutomation() {
      // this.$emit("close");
      this.$emit("edit");
    },
    async toggleAutomation() {
      await this.$store.dispatch("automations/toggleAutomation", this.auto);
    },
  },
};
</script>
<style lang="scss" scoped>
.automationCard {
  min-height: 260px;
  // border-top: inset 16px solid #000;
  padding: 32px 28px 16px 28px;
  position: relative;
  overflow: hidden;
  .automationCard-header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    // align-items: center;
    .automationCard-header-actions {
      margin-top: 8px;
      min-width: 108px;
      min-height: 10px;
      margin-inline-start: 124px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: baseline;
    }
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 15px;
    background: rgba(122, 0, 204, 0.4);
  }
}
@media screen and (max-width: 600px) {
  .automationsContainer {
    gap: 16px;
  }
  .automationCard {
    min-height: 80px;
    &::before {
      height: 10px;
    }
    .automationCard-header {
      flex-direction: column;
      .automationCard-header-actions {
        min-width: 0;
        min-height: 0;
        width: 100%;
        margin: 0;
        gap: 20px;
      }
    }
  }
}

.ifRowText {
  line-height: 1.1;
}
</style>
